import React, {
  forwardRef,
  ForwardRefRenderFunction,
  HTMLProps,
  PropsWithChildren,
} from 'react';

interface SettingButtonProps extends HTMLProps<HTMLDivElement> {
  isActive?: boolean;
}

const SettingButton: ForwardRefRenderFunction<
  HTMLDivElement,
  PropsWithChildren<SettingButtonProps>
> = ({ children, isActive, disabled, onClick, ...props }, ref) => {
  return (
    <div
      ref={ref}
      css={(theme) => ({
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: 4,
        height: 32,
        padding: '0 4px',
        borderWidth: 1,
        borderColor: theme.colors.stroke,
        cursor: disabled ? 'not-allowed' : 'pointer',
        backgroundColor: isActive
          ? theme.colors.defaultButtonActive
          : theme.colors.defaultButton,
        color: disabled ? theme.colors.muted : theme.colors.content,
        whiteSpace: 'nowrap',
        ':hover': {
          backgroundColor: disabled
            ? undefined
            : theme.colors.defaultButtonActive,
        },
      })}
      onClick={(e) => !disabled && onClick && onClick(e)}
      {...props}
    >
      {children}
    </div>
  );
};
export default forwardRef<
  HTMLDivElement,
  PropsWithChildren<SettingButtonProps>
>(SettingButton);
